module.exports = __webpack_public_path__ + "img/SI_GABY.0923341a.png";